/**
 * Filter Definitions Index
 *
 * Exports all available filter definitions
 */

import { FilterDefinition } from '../types';
import { nodeTypeFilter } from './nodeTypeFilter';
import { nodeIdFilter } from './nodeIdFilter';
import { nameFilter } from './nameFilter';
import { domainFilter } from './domainFilter';
import { edgeFilter } from './edgeFilter';
import { flagFilter } from './flagFilter';
import { meaningFilter } from './meaningFilter';

/**
 * All available filter definitions
 */
export const allFilterDefinitions: Record<string, FilterDefinition> = {
  nodeType: nodeTypeFilter,
  nodeId: nodeIdFilter,
  name: nameFilter,
  domain: domainFilter,
  edge: edgeFilter,
  flag: flagFilter,
  meaning: meaningFilter,
};

// Re-export individual filters for direct import
export { nodeTypeFilter } from './nodeTypeFilter';
export { nodeIdFilter } from './nodeIdFilter';
export { nameFilter } from './nameFilter';
export { domainFilter } from './domainFilter';
export { edgeFilter } from './edgeFilter';
export { flagFilter, HAS_SVARAS_FLAG, FLAG_LABELS } from './flagFilter';
export {
  meaningFilter,
  stampMeaningScope,
  MEANING_SCOPE_IN,
  MEANING_SCOPE_OTHER,
  type MeaningScope,
} from './meaningFilter';
